import axios from "axios";
import { API_BASE_URL } from "../config";

export interface ExpressionProfileBubble {
  // Define the shape of a bubble data item if known, else use 'any'
  [key: string]: any;
}

class ExpressionProfileClient {
  /**
   * Fetch bubble plot data for expression profile
   * Tries API, falls back to mock data
   */
  private baseURL: string = API_BASE_URL;

  async getDiseaseData(disease: string): Promise<ExpressionProfileBubble[]> {
    try {
      // Try to fetch from the API
      const response = await axios.get(
        `${this.baseURL}/api/tess/gene-explorer/data/${disease}`,
      );

      // Transform API response if needed (identity mapping for now)
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.warn(
        "Failed to fetch disease data from API, using mock data:",
        error,
      );

      throw error;
    }
  }
}

export const expressionProfileClient = new ExpressionProfileClient();
